'use client'

import { B2bInsurance } from '@/screens/B2bInsurance'

const B2bInsurancePageContent = () => {
	return <B2bInsurance />
}

export function B2bInsuranceClient() {
	return <B2bInsurancePageContent />
}
